import type { ReactNode } from 'react';
import { useSidebar } from './AppShell';

interface Props {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}

export function PageHeader({ title, subtitle, actions }: Props) {
  const { toggle } = useSidebar();

  return (
    <header>
      <div className="brand-top-rule" />
      <div className="page-pad pt-4 pb-3 sm:pt-5">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between sm:gap-4">
          <div className="flex items-start gap-3">
            <button
              type="button"
              onClick={toggle}
              className="brand-btn brand-btn-ghost shrink-0 -ml-1 mt-0.5 sidebar-toggle-mobile"
              style={{ padding: '0.25rem' }}
              aria-label="Open navigation"
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="var(--color-petrol)" strokeWidth="2" strokeLinecap="round">
                <line x1="3" y1="6" x2="21" y2="6" />
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="18" x2="21" y2="18" />
              </svg>
            </button>
            <div className="min-w-0">
              <h1 className="text-[1.375rem] font-semibold leading-tight text-petrol tracking-tight sm:text-[1.5rem] lg:text-[1.75rem]">
                {title}
              </h1>
              {subtitle && (
                <p className="mt-1 text-[0.8125rem] text-muted-slate leading-snug">
                  {subtitle}
                </p>
              )}
            </div>
          </div>
          {actions && (
            <div className="flex flex-wrap items-center gap-2 shrink-0">
              {actions}
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
